import React from 'react';

function Confidence({index, message}) {
	let percent = Math.round(message.text * 10000)/100;
	let color = (percent >= 75)? 'blue' : (percent >= 50)? 'green' : (percent >= 25)? 'yellow' : 'red';
	
	return <span className={color}>신뢰도 {percent}% </span>;
}

export default Confidence;